<template>
  <div class="mfa-required-error" :key="$store.state.locale">
    <div class="mfa-dialog">
      <div class="mfa-dialog__header">
        <span class="mfa-dialog__title">{{ $t('error.mfa-required.title') }}</span>
        <button
          class="mfa-dialog__close"
          @click="onContinue">
          ✕
        </button>
      </div>

      <div class="mfa-dialog__body">
        <div class="mfa-dialog__message">
          {{ $t('error.mfa-required.message1') }}
        </div>
        <div class="mfa-dialog__message">
          {{ $t('error.mfa-required.message2') }}
        </div>
      </div>

      <div class="mfa-dialog__footer">
        <a
          :href="learnMoreUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="mfa-dialog__learn-more">
          {{ $t('error.mfa-required.learnMore') }}
        </a>
        <div class="mfa-dialog__buttons">
          <el-button
            type="primary"
            @click="onContinue">
            {{ $t('error.mfa-required.continue') }}
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const LEARN_MORE_URL = 'https://care.acronis.com/s/article/71850-Acronis-Cyber-Protect-Home-Office-Two-factor-authentication?language=en_US';

export default {
  name: 'MfaRequiredError',

  computed: {
    learnMoreUrl() {
      return LEARN_MORE_URL;
    }
  },

  methods: {
    onContinue() {
      // Try to go to Account page of Family Dashboard through Login App
      // see {redirectionManager#redirectWithReturnUrl} in Login App

      // take the login page URL from "/session" API endpoint
      const loginApp = this.$store.getters.loginApp || '';
      let loginAppOrigin = 'https://cloud.acronis.com/';

      try {
        loginAppOrigin = new URL(loginApp).origin;
      } catch (ex) {}

      window.location.assign(`${loginAppOrigin}?return_url=/ui/#/account`);
    }
  }
};
</script>

<style lang="scss" scoped>
.mfa-required-error {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(58, 72, 94, 0.85);
  outline: none;
  user-select: none;
}

.mfa-dialog {
  width: 560px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  outline: none;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px 16px;
    border-bottom: 1px solid #e4e7ed;
    outline: none;
  }

  &__title {
    font-size: 18px;
    font-weight: 500;
    color: #303133;
  }

  &__close {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 16px;
    color: #909399;
    padding: 4px;
    line-height: 1;
    outline: none;

    &:hover {
      color: #303133;
    }
  }

  &__body {
    padding: 16px 24px;
    background-color: #f5f7fa;
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  &__message {
    padding: 12px 16px;
    font-size: 14px;
    color: #303133;
    line-height: 1.6;
    background-color: inherit;
    outline: none;
  }

  &__footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 24px 20px;
    border-top: 1px solid #e4e7ed;
  }

  &__learn-more {
    font-size: 14px;
    color: #409eff;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  &__buttons {
    display: flex;
    gap: 8px;
  }
}
</style>
